export default __webpack_public_path__ + "static/media/brewers-guild.7f88d4a2.jpg";